/** Local static assets only — no external image URLs in the app. */

export const PLACEHOLDERS = {
  product: '/placeholders/product.svg',
  store: '/placeholders/store.svg',
  avatar: '/placeholders/avatar.svg',
  category: '/placeholders/category.svg',
  banner: '/placeholders/banner.svg',
  promo: '/placeholders/promo.svg',
  appIcon: '/placeholders/app-icon.svg',
  /** Black mark on transparent — use with BrandLogo / CSS mask */
  logoMark: '/placeholders/logo-mark.png',
  /** Logo for dark backgrounds (light / white mark) */
  logoOnDark: '/placeholders/logo-light.svg',
  /** Logo for light backgrounds (dark / black mark) */
  logoOnLight: '/placeholders/logo-dark.svg',
} as const;

export const PRODUCT_IMAGE_FALLBACKS = Array.from({ length: 8 }, () => PLACEHOLDERS.product);

export function brandLogoSrc(darkBackground: boolean): string {
  return darkBackground ? PLACEHOLDERS.logoOnDark : PLACEHOLDERS.logoOnLight;
}

/** Tailwind text color class for the brand mark on a given background */
export function brandLogoTone(darkBackground: boolean, gold = false): string {
  if (gold) return 'text-gold';
  return darkBackground ? 'text-white' : 'text-stone-900';
}
